import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'

export const DriverPosition = withFacetContext(
    FacetName.driver_position,
    withFilterContext(FilterName.driver_position, SearchFiltersDropdown, {
        hideLabel: true,
        title: 'Driver position',
    })
)
